import React from 'react';
import { SxStyle } from '../../../../../types';
import { useStringsContext } from '../../../../../contexts/strings';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import { SquadPlayer } from '../../types';
import Box from '@mui/material/Box';
import DeleteIcon from '@mui/icons-material/Delete';
import Button from '@mui/material/Button';
import PlayerSelect from './player-select';
import PlayerAvatar from '../../../../common/player-avatar';
import { useHistory } from 'react-router-dom';

const styles: SxStyle = {
  container: {
    paddingLeft: '16px',
    paddingRight: '16px',
  },
  infoItem: (theme) => ({
    color: theme.palette.grey[600],
  }),
  chip: {
    marginRight: '8px',
  },
};

interface Props {
  selectedSquad: SquadPlayer[];
  isLoading: boolean;
  player: SquadPlayer;
  onDeletePlayer: () => void;
  onSelectedPlayer: (player: SquadPlayer) => void;
  backPage?: string;
  isReadOnly?: boolean;
}

const PlayerHeader = ({
  selectedSquad,
  isLoading,
  player,
  onDeletePlayer,
  onSelectedPlayer,
  isReadOnly,
}: Props) => {
  const { strings } = useStringsContext();

  return (
    <Box sx={styles.container}>
      <Grid container spacing={4}>
        <Grid item>
          <PlayerAvatar
            size="large"
            srcImage={player.images?.sefImagePng}
            fullName={player.displayName || player.fullName}
          />
        </Grid>
        <Grid item container xs justifyContent={'center'} direction={'column'}>
          <Grid item>
            {player.activeCurrentClub?.active && !player.healthStatus?.injured && (
              <Chip sx={styles.chip} label={strings.squadPlayer.active} color="success" />
            )}
            {player.healthStatus?.injured && (
              <Chip sx={styles.chip} label={strings.squadPlayer.injured} color="injured" />
            )}
            {player.activeCurrentClub?.status && player.activeCurrentClub?.status !== 'regular' && (
              <Chip
                sx={styles.chip}
                label={strings.squadPlayer[player.activeCurrentClub?.status]}
                color={player.activeCurrentClub?.status === 'temporary' ? 'info' : 'secondary'}
              />
            )}
          </Grid>
          <Grid item>
            <Typography variant="h4" noWrap>
              {player.displayName || player.fullName}
            </Typography>
          </Grid>
          <Grid item sx={styles.infoItem}>
            <Typography variant="body1">
              {player.position?.primary
                ? strings.squadPlayerPositions[player.position?.primary]
                : ''}
            </Typography>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container spacing={2}>
            <Grid item>
              <PlayerSelect
                selectedSquad={selectedSquad}
                isLoading={isLoading}
                player={player}
                onSelectedPlayer={onSelectedPlayer}
              />
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="error"
                onClick={onDeletePlayer}
                startIcon={<DeleteIcon />}
                disabled={isReadOnly}
              >
                {strings.squad.removePlayer}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PlayerHeader;
